import { FileTypes } from 'types/baseTypes';
import { Receipt } from './receipt.model';

export interface ReceiptColumnInfo {
  columnKey: string;
  columnLabel: string;
  priority: number;
  isEnabled: boolean;
  showAlways: boolean;
  isFocused: boolean;
}

export interface GetReceiptsResponse {
  transactions: Receipt[];
  filteredCount: number;
  columnInfo?: ReceiptColumnInfo[];
}

export type ReceiptSearchKey = 'receiptNo' | 'cardNo' | 'customer' | 'invoiceNo' | 'search';

export interface GetReceiptsPayload {
  teamId: number;
  limit?: number;
  page?: number;
  source?: string;
  type?: FileTypes;
  status?: ReceiptStatus[];
  tipAmountNE?: number | null;
  createdBy?: string[];
  customerId?: string[];
  paymentMethod?: string[];
  createdAtFrom?: string | null;
  createdAtTo?: string | null;
  sourceType?: string[];
  selectedIds?: string[];
  amount?: string | null;
  sortBy?: string;
  sortOrder?: string;
  searchKey?: ReceiptSearchKey | null;
  searchValue?: string | null;
}

export interface PostConfirmRefundPayload {
  teamId: string;
  transactionId: string;
}

export interface PostConfirmRefundResponse {
  futurePayouts: string;
  pendingPayouts: string;
  teamBankingBalance: string;
}

export interface PostInitiateRefundPayload {
  teamId: string;
  parentID: string;
  amount: string;
  reason: string;
  refundFlow: boolean;
  autoDebitFlow: boolean;
}

export enum ReceiptStatus {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
  REFUNDED = 'REFUNDED',
  BLOCKED = 'BLOCKED',
  TIMED_OUT = 'TIMED_OUT',
  INITIATED = 'INITIATED',
  PENDING = 'PENDING',
  REFUND_INITIATED = 'REFUND_INITIATED',
  REFUND_RETURNED = 'REFUND_RETURNED',
  REFUND_FAILED = 'REFUND_FAILED',
  REFUND_CANCELLED = 'REFUND_CANCELLED',
  VOID = 'VOID',
  DISPUTED = 'DISPUTED',
  RETURNED = 'RETURNED'
}
